import { useState } from "react";

import { EmailValidate, FormValidate } from "../../../components/formValidate";
import Snackbar from "../../../components/snackbar/snackbar";
import Loader from "../../../components/loader/loader";
import ResetPasswordModal from "../../../layout/userlayout/components/header/resetPasswordModal";
import "./login.css";
import { companyLogin, forgotPassword } from "./auth.api";
import jwtDecode from "jwt-decode";
let required = ["email", "password"];
export default function Companylogin(props) {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [error, setError] = useState({});
  const [submit, setSubmit] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [showForgot, setShowForgot] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [resetPasswordToken, setResetPasswordToken] = useState("");
  const [pendingRedirectPath, setPendingRedirectPath] = useState("");

  const handleChange = (e) => {
    let erroremail = false;
    const { name, value } = e.target;

    if (name === "email") {
      erroremail = value ? !EmailValidate(value) : false;

      setError({ ...error, email: erroremail });
    }
    if (name === "password") {
      setError((prev) => ({ ...prev, password: !value }));
    }
    setFormData({ ...formData, [name]: value });
  };
  const handleSubmit = (e) => {
    setSubmit(true);
    const error = FormValidate(formData, required);
    setError(error);
    e.preventDefault();

    if (Object.keys(error).length === 0) {
      companyLogin(formData)
        .then((res) => {
          setSubmit(false);
          sessionStorage.setItem("token", res.token);

          // Decode token to check user type
          const decodedToken = jwtDecode(res.token);
          const isCompanyUser =
            decodedToken?.actor === "company_user" ||
            decodedToken?.user?.is_company_user === true ||
            decodedToken?.is_company_user === true ||
            decodedToken?.data?.is_company_user === true;
          const shouldShowResetPrompt =
            Number(
              decodedToken?.is_initial_login ??
                decodedToken?.user?.is_initial_login ??
                decodedToken?.data?.is_initial_login
            ) === 0;

          const userType = Number(decodedToken.user_type || decodedToken.user?.user_type || decodedToken.sub);

          const dashboardRoles = [0, 4, 5, 6, 8, 9, 10, 24];
          const adminRoles = [1, 2, 23];
          const publicRoles = [21, 27];
          let redirectPath = "/dashboard";

          if (adminRoles.includes(userType)) {
            props.adminLogin(res.token);
            redirectPath = "/admin-dashboard";
          } else if (dashboardRoles.includes(userType)) {
            props.login(res.token);
            redirectPath = "/dashboard";
          } else if (publicRoles.includes(userType)) {
            props.login(res.token);
            redirectPath = "/";
          } else {
            // Default fallback
            props.login(res.token);
            redirectPath = "/dashboard";
          }

          if (isCompanyUser && shouldShowResetPrompt) {
            sessionStorage.setItem("company_user_reset_password_prompt", "1");
            setResetPasswordToken(res.token);
            setPendingRedirectPath(redirectPath);
            setShowResetPassword(true);
          } else {
            sessionStorage.removeItem("company_user_reset_password_prompt");
            props.history.push(redirectPath);
          }
        })
        .catch((error) => {
          setSubmit(false);

          setSnackMessage(error.response.data.message);
          setIsSnackError(true);
          setSnackOpen(true);
        });
    } else {
      setSnackMessage("Please fill all mandatory fields.");
      setIsSnackError(true);
      setSnackOpen(true);
      setSubmit(false);
    }
  };
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
  };
  const handleForgotPassword = () => {
    if (!EmailValidate(forgotEmail)) {
      setSnackMessage("Please enter a valid email");
      setIsSnackError(true);
      setSnackOpen(true);
      return;
    }

    forgotPassword({ email: forgotEmail })
      .then((res) => {
        setSnackMessage("Password reset instructions sent to your email.");
        setIsSnackError(false);
        setSnackOpen(true);
        setShowForgot(false);
      })
      .catch((error) => {
        setSnackMessage(
          error?.response?.data?.message || "Failed to process request"
        );
        setIsSnackError(true);
        setSnackOpen(true);
      });
  };
  const handleForgot = () => {
    setShowForgot(!showForgot);
  };

  const handleResetPasswordClose = () => {
    setShowResetPassword(false);
    sessionStorage.removeItem("company_user_reset_password_prompt");

    if (pendingRedirectPath) {
      const nextPath = pendingRedirectPath;
      setPendingRedirectPath("");
      props.history.push(nextPath);
    }
  };
  return (
    <div className="area">
      <Loader open={submit} />
      <div className="login-container">
        <div
          className="login-section company-login"
          style={{
            height: 'auto',
            // height: ,
            width: 390,
            padding: 24,
            borderRadius: 8,
            boxShadow: '0 8px 24px rgba(0,0,0,0.12)'
          }}
        >
          {!showForgot ? (
            <form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <div className="login-header" style={{ letterSpacing: '0.08em' }}>Company Login</div>
              <div className="login-body d-flex justify-content-center align-items-center flex-column" style={{ padding: '0 8px' }}>
                <div>
                  <img src="/resources/img/login/login-avatar.png" alt="" />
                </div>
                <div className="number-label-comp " style={{ marginTop: 8, color: '#333' }}>Enter your credentials</div>

                <div className="w-100 mt-3" style={{ maxWidth: 380 }}>
                  <label className="form-label" style={{ fontSize: 14, marginBottom: 6 }}>
                    Username <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="login-input-field"
                    name="email"
                    placeholder="Enter your username"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    style={{ width: '100%', height: 40, border: '1px solid #ced4da', borderRadius: 6, padding: '8px 12px', letterSpacing: 0, background: '#fff' }}
                  />
                </div>

                <div className="w-100 mt-3" style={{ maxWidth: 380 }}>
                  <label className="form-label" style={{ fontSize: 14, marginBottom: 6 }}>
                    Password <span className="text-danger">*</span>
                  </label>
                  <input
                    type="password"
                    className="login-input-field"
                    name="password"
                    placeholder="Enter your password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                    style={{ width: '100%', height: 40, border: '1px solid #ced4da', borderRadius: 6, padding: '8px 12px', letterSpacing: 0, background: '#fff' }}
                  />
                </div>

                {/* <div className="text-end mt-2 forgot-link w-100" style={{ maxWidth: 380, textAlign: 'right', marginTop: 8 }}>
                  <span
                    style={{ cursor: "pointer", color: "#007bff", fontSize: 14 }}
                    onClick={handleForgot}
                  >
                    Forgot Password?
                  </span>
                </div> */}
              </div>

              <div className="login-action" style={{ marginTop: 16 }}>
                <button className="login-button" type="submit" disabled={submit}>
                  Login
                </button>
              </div>
            </form>
          ) : (
            <form autoComplete="off" noValidate>
              <div className="login-header">Forgot Password</div>
              <div className="login-body d-flex justify-content-center align-items-center flex-column">
                <div>
                  <img src="/resources/img/login/login-avatar.png" alt="" />
                </div>

                <div className="w-100 mt-3" style={{ maxWidth: 320 }}>
                  <label className="form-label" style={{ fontSize: 13 }}>Enter your email</label>
                  <input
                    type="email"
                    className="number"
                    name="forgotEmail"
                    placeholder="Email"
                    value={forgotEmail}
                    onChange={(e) => setForgotEmail(e.target.value)}
                    required
                    style={{ width: '100%' }}
                  />
                </div>

                <div className="text-end mt-2 forgot-link w-100" style={{ maxWidth: 320 }}>
                  <span
                    style={{ cursor: "pointer", color: "#007bff", fontSize: "14px" }}
                    onClick={handleForgot}
                  >
                    Back to Login
                  </span>
                </div>
              </div>

              <div className="login-action">
                <button className="login-button" type="button" onClick={handleForgotPassword}>
                  Submit
                </button>
              </div>
            </form>
          )}
          <Snackbar message={snackMessage} error={isSnackError} open={snackOpen} close={snackbarClose} />
        </div>
      </div>
      <ResetPasswordModal
        show={showResetPassword}
        onHide={handleResetPasswordClose}
        token={resetPasswordToken || props.state?.payload}
      />
    </div>
  );
}
